import _ from 'lodash';
import { HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  actions: {
    async [actionTypes.DO_GET_ACCOUNT]({ commit }, payload) {
      const { host, ...params } = payload;
      const { data } = await HTTP.get(`/accounts/${host}`, { params });
      const account = data.data.accounts[0];
      const key = btoa(`${account.api_key}:${account.api_secret}`);
      const headers = _.cloneDeep(HTTP.defaults.headers);
      headers.common.Account = key;
      HTTP.defaults.headers = headers;
      commit(mutationTypes.SET_ACCOUNT, account);
      return account;
    },
  },
  getters: {
    [getterTypes.GET_ACCOUNT]: state => state.account,
  },
  mutations: {
    [mutationTypes.SET_ACCOUNT](state, account) {
      state.account = account;
    },
  },
  state: {
    account: {},
  },
};
